module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({

            name: 'memberReportCodeHistory',
            group:"eprsvc",
            url:"/eprsvc/x-services/secure/member/history/v1/reportcode",
            headers: {},
            cache: false,

            //Changes for PM78639
            fetch: function(payLoad) {
                return this.post({ payload: payLoad });
            }
        });
    }]);
};